export const creativesConstants = {
  SET_CREATIVES: 'SET_CREATIVES',
  SELECT_CREATIVES: 'SELECT_CREATIVES',
  SET_CREATIVE_TYPES: 'SET_CREATIVE_TYPES',
  SELECT_CREATIVE_TYPE: 'SELECT_CREATIVE_TYPE',
  RESET_CREATIVE_STORE: 'RESET_CREATIVE_STORE',
};
